import { IIconBase } from '..'

const SaveIcon = ({ color = '#333', height = 20, width = 20 }: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 512.000000 512.000000'
      preserveAspectRatio='xMidYMid meet'
    >
      <g
        transform='translate(0.000000,512.000000) scale(0.100000,-0.100000)'
        fill={color}
        stroke='none'
      >
        <path
          d='M521 4944 c-169 -45 -301 -180 -346 -351 -23 -86 -23 -3980 0 -4066
45 -173 178 -307 350 -352 52 -13 293 -15 2035 -15 2155 0 2025 -3 2142 56 71
36 159 123 197 193 65 122 61 10 61 1818 0 1387 -2 1649 -14 1676 -18 41
-1012 1033 -1049 1047 -19 7 -552 10 -1675 9 -1405 0 -1655 -2 -1701 -15z
m1081 -826 c3 -520 3 -523 26 -568 35 -72 75 -114 144 -151 l63 -34 725 0 725
0 51 27 c76 40 107 70 145 140 l34 63 3 523 3 522 127 0 127 0 433 -433 432
-432 -2 -1597 c-3 -1595 -3 -1597 -24 -1624 -49 -66 -58 -69 -265 -72 l-189
-3 0 588 c0 490 -3 598 -15 646 -45 173 -178 307 -350 352 -88 22 -2381 23
-2468 0 -173 -45 -307 -178 -352 -350 -13 -50 -15 -152 -15 -648 l0 -588 -189
3 c-207 3 -216 6 -265 72 l-21 27 -3 1952 c-1 1074 0 1966 3 1984 7 40 49 91
90 109 23 10 136 13 527 14 l497 0 3 -522z m1598 42 l0 -480 -640 0 -640 0 0
480 0 480 640 0 640 0 0 -480z m566 -2426 c15 -11 37 -33 48 -48 21 -27 21
-39 24 -617 l2 -589 -1280 0 -1280 0 0 574 c0 383 4 584 11 603 14 37 47 73
84 89 25 11 240 13 1197 11 1161 -2 1167 -2 1194 -23z'
        />
      </g>
    </svg>
  )
}

export default SaveIcon
